export const defaultTotals = {
    totalListings: 0,
    totalSaleListings: 0,
    totalRentalListings: 0,
    totalViews: 0,
    totalSaleViews: 0,
    totalRentalViews: 0,
    totalOtherViews: null,
    totalLeads: 0,
    totalSaleLeads: 0,
    totalRentalLeads: 0,
    totalOtherLeads: null
};
//==
